import {
    Component,
    OnInit,
    Output,
    EventEmitter,
    Inject,
    ViewChild,
    ElementRef
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AssignmentService } from '@/services/assignment-student.service';
import { LoginService } from '@/services/login.service';

import { Assignment } from '@/structures/assignment';

@Component({
    selector: 'app-content-daily',
    templateUrl: './content-daily.component.html',
    styleUrls: ['./content-daily.component.scss'],
    standalone: false
})
export class ContentDailyComponent implements OnInit {
    @Output() openErrorDialog: EventEmitter<string> = new EventEmitter();

    @ViewChild('progression') private progression: ElementRef;

    eventsToDo = [];
    eventsDone = [];

    constructor(
        private assignmentService: AssignmentService,
        private loginService: LoginService,
        private dialogRef: MatDialogRef<ContentDailyComponent>,
        @Inject(MAT_DIALOG_DATA) public contentDaily: any
    ) {}

    ngOnInit() {
        this.contentDaily.events.map((dayevent) => {
            if (dayevent.type === 'call') {
                if (dayevent.bbb_status === 'closed') {
                    this.eventsDone.push(dayevent);
                } else {
                    this.eventsToDo.push(dayevent);
                }
            } else if (dayevent.type === 'training') {
                if (['not attempted', 'opened'].indexOf(dayevent.tracking.status) === -1) {
                    this.eventsDone.push(dayevent);
                } else {
                    this.eventsToDo.push(dayevent);
                }
            }
        });
    }

    getDate() {
        return new Date(this.contentDaily.date).toLocaleDateString();
    }

    getIcon(content) {
        return this.assignmentService.getIcon(content);
    }

    getContentLevel(content) {
        switch (content.level) {
            case 'parcours': {
                return 'le parcours';
            }
            case 'bloc': {
                return 'le bloc';
            }
            case 'competence': {
                return 'la compétence';
            }
            case 'module': {
                return 'le module';
            }
            case 'sequence': {
                return 'la séquence';
            }
        }
    }

    canViewScore(assignment) {
        if (assignment.tracking.score === undefined || assignment.tracking.score === null) {
            return false;
        }
        if (
            assignment.tracking.status === 'opened' ||
            assignment.tracking.status === 'not attempted'
        ) {
            return false;
        }
        if (
            assignment.type === 'quiz' &&
            (!assignment.canViewScore || assignment.tracking.attempt < 1)
        ) {
            return false;
        }

        switch (assignment.category) {
            case 'positionnement':
            case 'evaluation':
            case 'tp':
            case 'presentiel':
            case 'devoir':
                return true;

            case 'preparation':
            case 'ressource':
            case 'travail':
            case 'corrige':
            case 'guide':
            case 'url':
                return false;

            default:
                return false;
        }
    }

    getTrackingStatusIconStyle(assignment): string {
        if (assignment.updateinprogress) {
            return 'icon-Voirplus';
        }

        const statusWhatever = assignment.tracking.forcedStatus
            ? assignment.tracking.forcedStatus
            : assignment.tracking.status;

        switch (statusWhatever) {
            case 'not attempted':
                return 'icon-select';
            case 'opened':
                return 'icon-Progression40';
            case 'completed':
                return 'icon-online';
            case 'passed':
                return 'icon-Valide';
            case 'failed':
                return 'icon-Fermerdetails';
            default:
                return 'icon-select';
        }
    }

    getTrackingStatusText(assignment): string {
        if (assignment.updateinprogress) {
            return "En cours d'assignation";
        }

        let text: string;

        switch (assignment.tracking.status) {
            case 'not attempted':
                text = 'Non commencé';
                break;
            case 'opened':
                text = 'En cours';
                break;
            case 'completed':
                text = 'Terminé';
                break;
            case 'passed':
                text = 'Réussi';
                break;
            case 'failed':
                text = 'Non réussi';
                break;
            default:
                text = 'Non commencé';
                break;
        }
        if (!assignment.tracking.forcedStatus) {
            return text;
        } else {
            switch (assignment.tracking.forcedStatus) {
                case 'not attempted':
                    text = 'Non commencé';
                    break;
                case 'opened':
                    text = 'En cours';
                    break;
                case 'completed':
                    text = 'Terminé';
                    break;
                case 'passed':
                    text = 'Réussi';
                    break;
                case 'failed':
                    text = 'Non réussi';
                    break;
                default:
                    text = 'Non commencé';
                    break;
            }
            return `${text} (validé par ${assignment.tracking.forcedStatusAuthorName})`;
        }
    }

    isForcedStatus(assignment): string {
        return assignment.tracking.forcedStatus ? 'orange' : '';
    }

    canLaunchContent(assignment: Assignment) {
        return this.assignmentService.canLaunchContent(assignment);
    }

    launchContent($event: Event, assignment: Assignment): void {
        $event.stopImmediatePropagation();
        if (this.canLaunchContent) {
            this.assignmentService.launchContent(assignment);
        }
    }

    getUserInitial(event) {
        return (
            this.getReferent(event).lastname.toUpperCase().charAt(0).toUpperCase() +
            this.getReferent(event).firstname.charAt(0).toUpperCase()
        );
    }

    getReferent(event) {
        if (event.type === 'call') {
            event.owner.connectionStatus = 'offline';
            return event.owner;
        } else {
            event.referent.connectionStatus = 'offline';
            return event.referent;
        }
    }

    getConnectionStatus(event) {
        if (this.getReferent(event).connectionStatus === 'online') {
            return 'green';
        } else if (this.getReferent(event).connectionStatus === 'idle') {
            return 'orange';
        } else if (this.getReferent(event).connectionStatus === 'donotdisturb') {
            return 'red';
        }
    }

    canChatUser(event) {
        return (
            this.getReferent(event).id !== this.loginService.getUser().id &&
            this.getConnectionStatus(event) === 'green'
        );
    }

    chatUser(event) {
        if (this.canChatUser(event)) {
            const message: any = {
                startChat: JSON.stringify(this.getReferent(event))
            };
            (
                document.getElementById('footer-container') as HTMLIFrameElement
            ).contentWindow.postMessage(message, '*');
        }
    }

    /**
     * Ferme la fenêtre d'erreur
     */
    closeDialog() {
        this.dialogRef.close();
    }
}
